import {cva} from 'class-variance-authority';

export const toggleVariants = cva(
  `relative inline-flex shrink-0 items-center justify-center rounded-full border border-transparent font-urbanist text-sm font-normal text-neutral-800 transition-colors before:absolute before:rounded-full before:content-[''] focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none disabled:pointer-events-none [&>svg]:shrink-0`,
  {
    variants: {
      variant: {
        default: `
          bg-neutral-light
          hover:bg-secondary-50
          disabled:bg-neutral-50 disabled:text-neutral-300
          data-[state=on]:border-secondary-500
          data-[state=on]:bg-secondary-50
          data-[state=on]:text-secondary-500
        `,
        white: `
          bg-white
          hover:bg-secondary-50
          disabled:bg-neutral-50 disabled:text-neutral-300
          data-[state=on]:border-secondary-500
          data-[state=on]:bg-secondary-50
          data-[state=on]:text-secondary-500
        `,
        outline: `
          border-input bg-transparent
          hover:bg-secondary-50
          disabled:bg-neutral-50 disabled:text-neutral-300
          data-[state=on]:border-secondary-500
          data-[state=on]:bg-secondary-50
          data-[state=on]:text-secondary-500
        `,
        tag: 'cursor-default bg-secondary-50 border-secondary-500 text-secondary-500',
      },
      size: {
        default: 'h-11 px-4',
        medium: 'h-11 px-4',
        small: 'h-9 px-3 before:inset-x-0 before:-inset-y-1',
        large: 'h-13 px-5',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);
